/**
 * RdSAP API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ActuatorInfoVersion } from './actuatorInfoVersion';
import { ActuatorHealthStatusDetails } from './actuatorHealthStatusDetails';


/**
 * An endpoint which provides basic application health information. So a caller knows if the the API working
 */
export interface ActuatorHealth { 
    /**
     * UP — The component or subsystem is working as expected  DOWN — The component is not working  OUT_OF_SERVICE — The component is out of service temporarily  UNKNOWN — The component state is unknown
     */
    status: ActuatorHealth.StatusEnum;
    details?: ActuatorHealthStatusDetails;
    app: ActuatorInfoVersion;
}
export namespace ActuatorHealth {
    export type StatusEnum = 'UP' | 'DOWN' | 'OUT_OF_SERVICE' | 'UNKNOWN';
    export const StatusEnum = {
        Up: 'UP' as StatusEnum,
        Down: 'DOWN' as StatusEnum,
        OutOfService: 'OUT_OF_SERVICE' as StatusEnum,
        Unknown: 'UNKNOWN' as StatusEnum
    };
}


